<script>
    import Loading from "../../lib/components/Loading.svelte";
    import NewGamer from "../../lib/components/modals/players/NewGamer.svelte";
    import FindIdByUsernameOrigin from "../../lib/components/modals/players/FindIdByUsernameOrigin.svelte";
    import backend from "../../server";
    import { onMount } from "svelte";
    import Pagination from "../../lib/components/Pagination.svelte";
    import alertify from "alertifyjs";
    import { ICONS } from "../../js/icons";
    import { getClientsForGroup } from "../../js/clientCurrencyMap.js";

    let loading = false;
    let showNewGamer = false;
    let findIdByUsernameOrigin = false;
    let gamers = { list: [] };
    let sessionClientCodes = [];
    let clientOptions = [];
    let clientSearch = '';
    let clientDropdownOpen = false;
    let filters = { page: 1, xpage: 20, selectedClient: "" };

    $: filteredClientOptions = clientOptions.filter(c =>
      c.code.toLowerCase().includes(clientSearch.toLowerCase()) ||
      (c.namesite || '').toLowerCase().includes(clientSearch.toLowerCase())
    );

    function selectClient(code) {
        clientDropdownOpen = false;
        filters.selectedClient = code;
        filters.clientcode = code;
        const opt = clientOptions.find(o => o.code === code);
        clientSearch = opt ? `${opt.namesite} (${opt.code})` : code;
        list();
    }
    const cleanCode = (code) => {
        if (!code) return code;
        if (code === "PGEU-001") return "PGEU";
        if (code === "PGTN-001") return "PGTN";
        return code;
    };
    function getClientCodesFromSession() {
        try {
            const u = JSON.parse(sessionStorage.getItem('user') || '{}');
            if (u.bo_client_codes && u.bo_client_codes.length > 0) return u.bo_client_codes;
            const code = u.client_code || '';
            return getClientsForGroup(code);
        } catch { return []; }
    }
    onMount(async () => {
        sessionClientCodes = getClientCodesFromSession();
        if (sessionClientCodes.length > 0) {
            filters.selectedClient = sessionClientCodes[0];
            filters.clientcode = sessionClientCodes[0];
        } else {
            filters.clientcode = "";
            filters.selectedClient = "";
        }
        try {
            const codes = sessionClientCodes;
            const res = await backend.client.list({ xpage: 500, page: 1 });
            const list = res.data?.list ?? res.data ?? [];
            clientOptions = codes.map(code => {
                const found = Array.isArray(list) ? list.find(c => c.code === code) : null;
                return { code, namesite: found?.namesite || found?.businessname || code };
            });
            if (filters.selectedClient) {
                const opt = clientOptions.find(o => o.code === filters.selectedClient);
                if (opt) clientSearch = `${opt.namesite} (${opt.code})`;
            }
        } catch {}
        list();
    });
    const list = async () => {
        let baseFilters = { ...filters };
        if (baseFilters.platform === "") delete baseFilters.platform;
        if (baseFilters.currency === "") delete baseFilters.currency;
        if (baseFilters.country === "") delete baseFilters.country;
        if (baseFilters.search === "") delete baseFilters.search;
        const chosenClient = baseFilters.selectedClient && baseFilters.selectedClient !== "" ? baseFilters.selectedClient : null;
        try {
            loading = true;
            if (chosenClient) {
                const params = { ...baseFilters, clientcode: cleanCode(chosenClient) };
                delete params.selectedClient;
                let response = await backend.gamers.listV2(params);
                gamers = response.data;
                return;
            }
            if (sessionClientCodes.length > 1) {
                const requests = sessionClientCodes.map(cc => {
                    const realCodeForBackend = cleanCode(cc);
                    const params = { ...baseFilters, clientcode: realCodeForBackend, page: 1, xpage: filters.xpage };
                    delete params.selectedClient;
                    return backend.gamers.listV2(params)
                        .then(r => ({ code: cc, data: r.data }))
                        .catch(e => ({ code: cc, data: { list: [], total: 0, page: 1, xpage: filters.xpage } }));
                });
                const responses = await Promise.all(requests);
                const mergedMap = new Map();
                let mergedTotal = 0;
                let anyXpage = filters.xpage || 20;
                for (const r of responses) {
                    const listPart = Array.isArray(r.data.list) ? r.data.list : [];
                    for (const item of listPart) { if (!mergedMap.has(item.id)) mergedMap.set(item.id, item); }
                    mergedTotal += Number(r.data.total ?? listPart.length);
                    anyXpage = r.data.xpage ?? anyXpage;
                }
                const mergedList = Array.from(mergedMap.values());
                gamers = {
                    list: mergedList,
                    total: mergedTotal,
                    page: 1,
                    xpage: anyXpage
                };
                return;
            }
            const params = { ...baseFilters };
            if (params.clientcode) params.clientcode = cleanCode(params.clientcode);
            else delete params.clientcode;
            if (params.selectedClient) delete params.selectedClient;
            let response = await backend.gamers.listV2(params);
            gamers = response.data;
        } catch (error) {
            alertify.error("No se puede listar");
            console.error("Error list:", error);
        } finally {
            loading = false;
        }
    };
    let selectedUsernameOrigin = "";
    const onPageClick = (page) => {
        filters.page = page;
        list();
    };
</script>

<!-- === MISMO LAYOUT QUE TrxPageLite === -->
<div class="bo-main">
    <div class="menu-filter">
        <div class="row-bo">
            <div style="grid-column: 1 / -1;">
                <form class="bo-inline-filter" on:submit|preventDefault={list} style="display:flex; gap:0.5rem; align-items:flex-start; justify-content:center; flex-wrap:wrap;">
                    <div>
                        <label for="searchInput" style="font-size:0.8rem; color:#444; line-height:1; margin-bottom:0.25rem; display:block;">Buscar usuario</label>
                        <div style="display:flex; gap:0.3rem;">
                            <input id="searchInput"
                                    bind:value={filters.search}
                                    class="form-control"
                                    placeholder="Nombre de Usuario"
                            />
                            <button type="submit" class="btn btn-primary btn-sm" title="Buscar">
                                {@html ICONS.search}
                            </button>
                        </div>
                    </div>
                    {#if sessionClientCodes.length > 1}
                        <div style="position:relative;">
                            <label for="clientSearch" style="font-size:0.8rem; color:#444; line-height:1; margin-bottom:0.25rem; display:block;">Filtrar sitio</label>
                            <input id="clientSearch" class="form-control" type="text"
                                   bind:value={clientSearch}
                                   on:focus={() => { clientDropdownOpen = true; clientSearch = ''; }}
                                   on:blur={() => setTimeout(() => {
                                       clientDropdownOpen = false;
                                       if (filters.selectedClient) {
                                           const opt = clientOptions.find(o => o.code === filters.selectedClient);
                                           if (opt) clientSearch = `${opt.namesite} (${opt.code})`;
                                       }
                                   }, 200)}
                                   placeholder="Buscar sitio..." />
                            {#if clientDropdownOpen && filteredClientOptions.length > 0}
                                <div class="search-dropdown">
                                    {#each filteredClientOptions as opt}
                                        <button class="search-dropdown-item" class:active={opt.code === filters.selectedClient}
                                                on:mousedown={() => selectClient(opt.code)}>
                                            <span class="opt-name">{opt.namesite}</span>
                                            <span class="opt-code">{opt.code}</span>
                                        </button>
                                    {/each}
                                </div>
                            {/if}
                        </div>
                    {/if}
                </form>
            </div>
        </div>
    </div>

    <div class="bo-body-table-trx">
        <Loading bind:loading />
        {#if !loading}
            <div style="overflow-x: auto;">
                <table class="table table-striped table-sm">
                    <thead class="table-dark">
                    <tr class="bo-table-title">
                        <th>ID</th>
                        <th>Usuario</th>
                        <th>Sitio</th>
                        <th>País</th>
                        <th>Moneda</th>
                        <th>Balance actual</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#if gamers.list.length}
                        {#each gamers.list as gamer}
                            <tr class="bo-table-data">
                                <td>{gamer.id}</td>
                                <td>{gamer.firstname}</td>
                                <td>{gamer.client.namesite}</td>
                                <td>{gamer.country}</td>
                                <td>{gamer.currency}</td>
                                <td class="fw-bold">{gamer.balance ?? "-"}</td>
                            </tr>
                        {/each}
                    {:else}
                        <tr class="bo-table-data">
                            <td colspan="6">No se encontraron registros</td>
                        </tr>
                    {/if}
                    </tbody>
                </table>
            </div>

            {#if gamers.list.length}
                <Pagination
                        bind:total={gamers.total}
                        bind:xpage={gamers.xpage}
                        bind:current={gamers.page}
                        {onPageClick}
                />
            {/if}
        {/if}
    </div>
</div>

{#if showNewGamer}
    <NewGamer bind:showNewGamer />
{/if}

{#if findIdByUsernameOrigin}
    <FindIdByUsernameOrigin
            bind:showFindIdByUsernameOrigin={findIdByUsernameOrigin}
            usernameOrigin={selectedUsernameOrigin}
    />
{/if}

<style>
    .bo-table-title {
        text-align: center;
        font-size: 0.9rem;
        background-color: rgb(158, 93, 80);
        color: white;
        border: 1px solid black;
    }
    .bo-table-data {
        text-align: center;
        font-size: 0.9rem;
    }
    .table.table-sm td {
        padding: 0.55rem 0.6rem;
    }
    .bo-inline-filter .form-control {
        height: 32px;
        padding: 0.25rem 0.5rem;
    }
    .bo-inline-filter input.form-control {
        width: min(380px, 90vw);
    }

    @media (max-width: 1024px) {
        .bo-main {
            padding: 1rem;
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
        .menu-filter {
            display: flex;
            flex-direction: column;
        }
        .bo-body-table-trx {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            position: relative;
        }
        .row-bo {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
    }
    @media (min-width: 1025px) {
        .bo-main {
            padding: 1rem;
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
        .menu-filter {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        }
        .bo-body-table-trx {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            position: relative;
        }
        .row-bo {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            flex-wrap: wrap;
            gap: 0.4rem;
        }
    }
    .search-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: #fff;
        border: 1px solid #ced4da;
        border-radius: 0.3rem;
        max-height: 220px;
        overflow-y: auto;
        z-index: 100;
        box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    }
    .search-dropdown-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0.4rem 0.6rem;
        border: none;
        background: none;
        cursor: pointer;
        font-size: 0.82rem;
        text-align: left;
    }
    .search-dropdown-item:hover,
    .search-dropdown-item.active { background: #f0f0f0; }
    .opt-name { font-weight: 600; color: #212529; }
    .opt-code { color: #0d6efd; font-size: 0.75rem; font-family: monospace; }
</style>
